"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionWrapper = exports.Separator = exports.Action = exports.IconContainer = exports.Content = exports.CrossStyle = exports.SecondaryText = exports.Label = exports.Wrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../../../../theme/colors");
exports.Wrapper = styled_components_1.default.div `
  display: ${({ $show }) => ($show ? "flex" : "none")};
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background-color: ${({ $type }) => {
    switch ($type) {
        case "error":
            return colors_1.RED_BACKGROUND;
        case "reassurance":
            return colors_1.PALE_GREEN;
        case "default":
            return colors_1.GREY4;
        default:
            return colors_1.YELLOW;
    }
}};

  width: inherit;
  position: relative;
  box-shadow: ${({ $type }) => $type === "default" &&
    `0px -1px 12px rgba(0, 0, 0, 0.06),
    0px 15px 16px rgba(0, 0, 0, 0.08), 0px 5px 14px rgba(0, 0, 0, 0.07)`};
`;
exports.Label = styled_components_1.default.label `
  font-family: SwegonBrown;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  word-wrap: break-word;
  text-align: justify;

  ${({ $type }) => {
    switch ($type) {
        case "error":
            return (0, styled_components_1.css) `
          background-color: ${colors_1.RED_BACKGROUND};
          color: ${colors_1.ORANGE};
        `;
        case "reassurance":
            return (0, styled_components_1.css) `
          background-color: ${colors_1.PALE_GREEN};
          color: ${colors_1.DARK_GREEN};
        `;
        case "default":
            return (0, styled_components_1.css) `
          background-color: ${colors_1.GREY4};
          color: ${colors_1.WHITE};
        `;
        default:
            return (0, styled_components_1.css) `
          background-color: ${colors_1.YELLOW};
          color: ${colors_1.YELLOW};
        `;
    }
}};

  ${({ $inlineTranslation }) => $inlineTranslation &&
    (0, styled_components_1.css) `
      label {
        font-weight: bold;
        font-size: 14px;
        line-height: 18px;
      }
    `}

  ${({ $type, $inlineTranslation }) => $type === "error" && $inlineTranslation
    ? (0, styled_components_1.css) `
          label {
            background-color: ${colors_1.RED_BACKGROUND};
            color: ${colors_1.ORANGE};
          }
        `
    : $type === "reassurance" && $inlineTranslation
        ? (0, styled_components_1.css) `
          label {
            background-color: ${colors_1.PALE_GREEN};
            color: ${colors_1.DARK_GREEN};
          }
        `
        : $type === "default" && $inlineTranslation
            ? (0, styled_components_1.css) `
          label {
            background-color: ${colors_1.GREY4};
            color: ${colors_1.WHITE};
          }
        `
            : (0, styled_components_1.css) `
          label {
            background-color: ${colors_1.YELLOW};
            color: ${colors_1.YELLOW};
          }
        `};
`;
exports.SecondaryText = styled_components_1.default.label `
  font-family: SwegonBrown;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 14px;
  display: flex;
  margin-top: 8px;
  align-items: center;
  text-align: justify;
  color: ${({ $type }) => {
    switch ($type) {
        case "error":
            return colors_1.ORANGE;
        case "reassurance":
            return colors_1.DARK_GREEN;
        case "default":
            return colors_1.WHITE;
        default:
            return colors_1.YELLOW;
    }
}};

  ${({ $inlineTranslation }) => $inlineTranslation &&
    (0, styled_components_1.css) `
      label {
        font-weight: normal;
        font-size: 14px;
        line-height: 14px;
      }
    `}
  label {
    color: ${({ $type, $inlineTranslation }) => {
    if (!$inlineTranslation) {
        return colors_1.YELLOW;
    }
    switch ($type) {
        case "error":
            return colors_1.ORANGE;
        case "reassurance":
            return colors_1.DARK_GREEN;
        case "default":
            return colors_1.WHITE;
        default:
            return colors_1.YELLOW;
    }
}};
  }
`;
exports.CrossStyle = styled_components_1.default.div `
  position: absolute;
  top: 3px;
  right: 3px;
  &:hover {
    cursor: pointer;
  }
`;
exports.Content = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  word-break: break-word;
  max-width: calc(100% - 120px);
`;
exports.IconContainer = styled_components_1.default.div `
  position: absolute;
  top: 0;
  right: 0;
  &:hover {
    cursor: pointer;
  }
  margin: 5px 5px 0 0;
  display: flex;
  flex-direction: row-reverse;
  grid-column-gap: 5px;
`;
exports.Action = styled_components_1.default.div `
  font-weight: bold;
  font-family: SwegonBrown;
  margin-right: 15px;
  cursor: pointer;
  font-size: 12px;
  margin-top: 4px;
  color: ${({ $type }) => $type === "default" && colors_1.WHITE};
`;
exports.Separator = styled_components_1.default.div `
  margin-right: 15px;
  opacity: 0.2;
  color: ${({ $type }) => $type === "default" && colors_1.WHITE};
`;
exports.ActionWrapper = styled_components_1.default.div `
  display: flex;
`;
//# sourceMappingURL=InfoBar.styles.js.map